export class CdcBackupModeCheckResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CdcBackupModeCheckResult.attributeTypeMap;
    }
    constructor() {
    }
}
